export default "__VITE_ASSET__DX6DOW9M__"